import React from "react";
import "./about.css";
const About = () => {
  return (
    <div className="section author" id="author">
      <div className="about container">
        <div className="author-content">
          <p className="section-subtitle">DER AUTOR</p>
          <div className="author-info">
          <div className="image">
              <img
                src="https://github.com/Brights-DevOps-2022-Script/DevOps-Daemons/blob/main/frontendlatest/src/pages/about/images/jorg.png?raw=true"
                alt=""
              />
          </div>
          <div>
            <h2 className="h2 section-title">Jörg Miethe</h2>
          </div>
          </div>
          <div className="section-text">
            Im Studium sind mir besonders zwei Arten von Professoren in
            Erinnerung geblieben:
            <br />
            <br />
            1. Die "Schlechten", welche einfache Dinge unnötig verkompliziert
            hatten.
            <br />
            <br />
            2. Die "Guten" konnten auch komplexe und komplizierte Themen einfach
            erklären.
            <br />
            <br />
            Besonders gelungen war das Beispiel in der Thematik Kostenrechnung.
            Unser Professor hat die Vorlesungsreihe mit der Ankündigung
            begonnen, dass alle Studenten als junge Diplom-Kaufleute ganz sicher
            einen der wichtigsten Abteilung in jeder Firma anvertraut bekommen,
            die Kaffeeküche.... Das ganze Semester durch, wurden alle neuen
            Themengebiete anhand des "Kaffeeküchenbeispiels", eingeführt....
            Wartungskosten = Entkalkungstablette, Chargenabhängige Kosten = das
            Extra-Lot Kaffeemehl 'für den Geschmack' bei jeder Kanne.... Auch
            heute noch, 20 Jahre später, leite ich mir Kostenträger-Arten oder
            Sammler anhand von Kaffeemehl und Kaffeetassen her. Es gibt immer
            wieder sehr schöne Bilder in unserem Unterricht, wie z.B. die
            Pillendose mit den Kalendertagen als Beispiel für ein Array. Der
            DevOpsComic-Buch Verlag ist mein trauriger Versuch ein durchgängiges
            Beispiel für den 'mir größtenteils immer noch unbekannten'
            Devops-Zyklus zu finden. Hauptsächlich um mir die Dinge selbst zu
            erklären und wichtiger noch zu erinnern... Angefangen hat das
            Beispiel als Theater, danach war es eine Filmproduktion und endete
            letztendlich als Verlag.
            <br />
            <br />
            Vermutlich, weil ich die "Continious-Delivery" am besten dahinein
            quetschen konnte....
          </div>
        </div>
        <div className="author-content">
          <p className="section-subtitle">DER AUTOR</p>
          <div className="author-info">
          <div className="image">
              <img
                src="https://media.licdn.com/dms/image/C5603AQFDys5Htra0nQ/profile-displayphoto-shrink_400_400/0/1662128333451?e=1682553600&v=beta&t=BrX1hNnjShX4JB9j2mUaobq3yugAlwBCuoK_R9fjNgc"
                alt=""
              />
          </div>
          <div>
            <h2 className="h2 section-title">Felix Strauß</h2>
          </div>
          </div>

          <div className="section-text">
            <p>
              Während meines Offizierslehrgangs, war das schwerste Fach:
              „Recht“, die Durchfallquote war recht hoch und unsere Lehrer zuvor
              waren meistens, eines älteren Schlags und zu sehr in ihrem
              Fachwissen vertieft, dass sie es uns Neulingen mehr schlecht als
              Recht versucht hatten beizubringen. Doch mein Rechtslehrer war ein
              anderes Kaliber, durch seinen großen Erfahrungsschatz konnte er
              jedes Gesetz mit einer lustigen, traurigen aber definitiv immer
              interessanten Geschichte aus seinem Leben erklären. Dies zeigte
              Wirkung und unser gesamter Hörsaal bestand die Prüfung was mir
              erneut verdeutlichte, was ich aus meiner vorherigen Schulerfahrung
              gelernt hatte. Merksätze, bildliche Erklärungen sind etwas
              Greifbareres als komplexe Diagramme oder niedergeschriebene
              Paragrafen. Sie erleichtern uns, komplexe Themen einfach zu
              erklären. Deshalb begeisterte mich Jörg seine Idee und ich wollte
              unbedingt unser Projekt vorantreiben, damit wir etwas Bleibendes
              schaffen konnten, für uns zur Festigung unseres Wissens und für
              andere, um komplexe Thematiken besser nachvollziehen zu können,
              verpackt in Abenteuer und Humor.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
